import styled from "styled-components";
import { device } from "../../../styles/breakpoints";

//FloorPlan.jsx

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const ImageContainer = styled.div`
  /* Mobile: Full width, auto height */
  max-width: 100%;
  max-height: ${({ dashboard }) =>
    dashboard ? "300px" : ({ widgetSize }) => (widgetSize ? "30vh" : "100%")};
  height: ${({ dashboard, containerHeight, widgetSize }) =>
    dashboard
      ? "auto"
      : containerHeight
      ? containerHeight
      : widgetSize
      ? "400px"
      : "450px"};
  width: ${({ dashboard }) => (dashboard ? "100%" : "auto")};
  flex-shrink: 0;
  margin-top: ${({ dashboard, widgetSize }) =>
    dashboard ? "0px" : widgetSize ? "0px" : "8px"};
  margin-bottom: ${({ dashboard, widgetSize }) =>
    dashboard ? "0px" : widgetSize ? "0px" : "8px"};
  background: lightgray -1.622px -1.775px / 101.117% 100.352% no-repeat, #fff;
  position: relative;
  display: flex;

  /* Tablet: Medium height */
  @media ${device.tablet} {
    max-height: ${({ dashboard }) =>
      dashboard ? "400px" : ({ widgetSize }) => (widgetSize ? "35vh" : "100%")};
    height: ${({ dashboard, containerHeight, widgetSize }) =>
      dashboard
        ? "auto"
        : containerHeight
        ? containerHeight
        : widgetSize
        ? "500px"
        : "500px"};
    margin-top: ${({ dashboard, widgetSize }) =>
      dashboard ? "0px" : widgetSize ? "0px" : "10px"};
    margin-bottom: ${({ dashboard, widgetSize }) =>
      dashboard ? "0px" : widgetSize ? "0px" : "10px"};
  }

  /* Desktop: Standard height */
  @media ${device.desktop} {
    max-width: ${({ dashboard }) => (dashboard ? "75.25rem" : "100%")};
    max-height: ${({ dashboard }) =>
      dashboard ? "450px" : ({ widgetSize }) => (widgetSize ? "35vh" : "100%")};
    height: ${({ dashboard, containerHeight, widgetSize }) =>
      dashboard
        ? "auto"
        : containerHeight
        ? containerHeight
        : widgetSize
        ? "600px"
        : "550px"};
    margin-top: ${({ dashboard, widgetSize }) =>
      dashboard ? "0px" : widgetSize ? "0px" : "13px"};
    margin-bottom: ${({ dashboard, widgetSize }) =>
      dashboard ? "0px" : widgetSize ? "0px" : "13px"};
  }
`;

export const ImageStyle = styled.img`
  width: 100%;
  height: ${({ widgetSize }) => (widgetSize ? "auto" : "auto")};
  object-fit: ${({ widgetSize }) => (widgetSize ? "" : "contain")};
  object-position: center center;
  max-height: 100%;
`;

export const MapControls = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin: 5px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  border-radius: 8px;
`;

export const Expand = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 10px;
  flex-direction: row;
  border-radius: 8px;
  background: var(--vds-background-primary-light, #fff);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
`;

export const ZoomButtonsBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 98px;
  height: 44px;
  flex-direction: row;
  gap: 24px;
  background: var(--vds-background-primary-light, #fff);
  padding: 9px;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
`;

export const Edit = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  width: 100%;
  height: auto;
  flex-direction: row;
  border-radius: 8px;
  background: var(--vds-background-primary-light, #fff);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
`;

export const MarkerStyle = styled.div`
  position: absolute;
  &:hover {
    transform: scale(1.2);
  }
`;

export const CriticalMarkerStyle = styled.div`
  position: absolute;
  display: flex;
  padding: var(--space-2X, 8px);
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--vds-feedback-error-ondark, #ff8027);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15),
    0px 1px 12px 0px rgba(0, 0, 0, 0.22);
  height: 35px;
  width: 35px;
  &:hover {
    transform: scale(1.2);
  }
`;

export const AlertMarkerStyle = styled.div`
  position: absolute;
  display: flex;
  width: 40px;
  height: 40px;
  background-color: ${(props) => props.color1};
  border-width: 5px;
  border-style: solid;
  border-color: ${(props) => props.color2};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.22),
    0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  background-image: url(${(props) => props.image1});
  &:hover {
    transform: scale(1.2);
  }
  &:active {
    background: ${(props) => props.color2};
    background-image: url(${(props) => props.image2});
  }
`;

export const CustomTooltip = styled.div`
  display: flex;
  width: 308px;
  height: 372px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-6X, 24px);
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--vds-background-primary-light, #FFF);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 20;
  transform: translate(-50%, -50%);
  // &::before {
  //   content: '';
  //   position: absolute;
  //   bottom: -10px; // Half the size of the arrow
  //   left: 50%;
  //   transform: translateX(-50%);
  //   border-width: 10px;
  //   border-style: solid;
  //   border-color: transparent transparent var(--vds-background-primary-light, #FFF) transparent;
  //   // Adjust the color to match the tooltip background
  }
`;

export const CriticalDetailsFrame = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-6X, 24px);
  align-self: stretch;
  width: 260px;
  height: 98px;
`;

export const CriticalVideoFrame = styled.div`
  width: 260px;
  height: 146px;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.5) 100%
    ),
    url(<path-to-image>), lightgray 50% / cover no-repeat;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CriticalButtonFrame = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  width: 260px;
  height: 32px;
`;

export const DetailsOfCriticalEvents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2X, 8px);
  flex: 1 0 0;
  width: 212px;
  height: 98px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FrameOne = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-1-x, 4px);
  width: 112px;
  height: 42px;
`;

export const FrameTwo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2-x, 8px);
  width: 250px;
  height: 48px;
`;

export const EditIconForFP = styled.div`
  position: absolute;
  top: 5%;
  right: 5%;
  z-index: 1;
`;

export const TickIconForFP = styled.div`
  position: absolute;
  top: 70%;
  right: 3%;
  z-index: 1;
  background: var(--vds-background-primary-light, #fff);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  display: inline-flex;
  padding: 4px;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const CloseIconForFP = styled.div`
  position: absolute;
  top: 85%;
  right: 3%;
  z-index: 1;
  background: var(--vds-background-primary-light, #fff);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  display: inline-flex;
  padding: 4px;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const EditControls = styled.div`
  position: absolute;
  bottom: 5px;
  right: 0px;
  margin: 10px;
  display: inline-flex;
  padding: 14px;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 16px;
  background: var(--vds-background-primary-light, #fff);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
`;
